import styled from 'styled-components'

export const Container = styled.div`
  position: fixed;
  width: 100%;
  display: flex;
  height: 64px;
  background-color: ${props => props.theme.colors.background.primary};
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
`

export const ReveniLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 64px;
  height: 64px;

  box-sizing: border-box;
  img {
    height: ${props => props.theme.size.S};
  }
`
export const InfoContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${props => `${props.theme.spacing.sp32}`};
  border-left: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
`

export const StoreInfo = styled.div`
  display: flex;
  gap: ${props => `${props.theme.spacing.sp32}`};
  align-items: center;
`

export const headerLinks = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => `${props.theme.spacing.sp16}`};

  a {
    text-decoration: none;
    color: black;

    &:hover {
      cursor: pointer;
    }

    :visited {
      color: black;
    }

    :link {
      color: black;
    }
  }
`

export const Divider = styled.div`
  border-left: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  height: 64px;
`
